import { FieldTeam, RailroadLink } from 'src/shared/api';
import { createAction, props } from '@ngrx/store';
import { FieldTeamDetail } from '../field-team-detail.models';

export const fieldTeamSaved = createAction(
	'[Field Team] Field Team Saved',
	props<{ fieldTeam: FieldTeam }>()
);

export const railroadSelected = createAction(
	'[Field Team] Railroad Selected',
	props<{ railroad: RailroadLink }>()
);

export const errorSavingFieldTeam = createAction(
	'[Field Team] Error Saving Field Team',
	props<{ error: any }>()
);
export const saveRequested = createAction(
	'[Field Team] Save Requested',
	props<{ shouldStayOnPage: boolean; formValue: FieldTeamDetail }>()
);

export const fieldTeamDetailDestroyed = createAction(
	'[FieldTeam] Field Team Detail Destroyed'
);

export const fieldTeamSelected = createAction(
	'[Field Team] Field Team Selected',
	props<{ fieldTeamId: number }>()
);

export const fieldTeamLoadedFromApi = createAction(
	'[Field Team] Field Team Loaded From Api',
	props<{ fieldTeam: FieldTeam }>()
);

export const fieldTeamLoadedFromStore = createAction(
	'[Field Team] Field Team Loaded From Store',
	props<{ fieldTeam: FieldTeam }>()
);

export const errorLoadingFieldTeam = createAction(
	'[Field Team] Error Loading Field Team',
	props<{ error: any }>()
);

export const newFieldTeamStarted = createAction(
	'[Field Team] New Field Team Started'
);

export const newFieldTeamSaved = createAction(
	'[Field Team] New Field Team Saved',
	props<{ fieldTeam: FieldTeam }>()
);
